<template>
    <Layout>
        <b-row>
            <b-col xl="2" sm="3">
                <keep-alive>
                    <Menu @back="handleBack"/>
                </keep-alive>
            </b-col>

            <b-col xl="10"  sm="9">
                <!-- main component here -->
                <Viewer @back="handleBack()" />
            </b-col>
        </b-row>
    </Layout>
</template>

<script>
import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
import {layoutMethods} from '@/state/helpers';
import Viewer from '@/components/documents/documentView.vue'
export default {
    data:() => ({

    }),
    components:{
        Layout,
        Menu,
        Viewer,
    },
    computed: {
        
    },
    methods: {
        ...layoutMethods,
        handleBack(){
            alert(' use router.back or something like that')
        },
    },
    mounted(){
        this.$nextTick(()=>{
            this.updateMenuType({
                type: 'documents_view',
                showMenu: true,
                showRoutes: true,
            })
        })
    },
    beforeDestroy(){
        this.updateMenuType({
            type: 'Nothing',
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>
